var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value:
            _vm.getFlagSharedShowFlightSearchResults === false ||
            _vm.getFlagSharedShowFlightSearchResultsAndBestPriceCaroussel ===
              true,
          expression:
            "getFlagSharedShowFlightSearchResults === false || getFlagSharedShowFlightSearchResultsAndBestPriceCaroussel === true",
        },
      ],
      key: _vm.componentKey,
      attrs: { id: "content" },
    },
    [
      _c("div", { staticClass: "container shortcode travel-ideas" }, [
        _c(
          "div",
          {
            staticClass: "block",
            staticStyle: { "margin-bottom": "20px !important" },
          },
          [
            _vm.modulo === "booking"
              ? [
                  _c("h1", { staticClass: "idea-title" }, [
                    _vm._m(0),
                    _vm._v(_vm._s(_vm.headlinecontent[_vm.getCurrentLocale])),
                  ]),
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.modulo === "flightplan"
              ? [
                  _c("h1", { staticClass: "idea-title" }, [
                    _vm._m(1),
                    _vm._v(
                      _vm._s(
                        _vm.headlinecontent_flightplan[_vm.getCurrentLocale]
                      )
                    ),
                  ]),
                ]
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "image-carousel style3 flex-slider",
                attrs: { "data-item-width": "270", "data-item-margin": "30" },
              },
              [
                _c("ul", { staticClass: "slides image-box style9" }, [
                  _c("li", [
                    _c("div", { staticStyle: { "margin-top": "4px" } }, [
                      _c(
                        "article",
                        {
                          staticClass: "box",
                          class: {
                            "has-discount":
                              _vm.getOffersSelectedDestination
                                .destinationOfferAptCode === "FUE",
                          },
                        },
                        [
                          _c("figure", [
                            _c(
                              "a",
                              {
                                staticClass: "hover-effect",
                                attrs: { href: "" },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    _vm.onClick_Destination("FUE")
                                  },
                                },
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: "/res/images/keydestinations/fue_fuerteventura_270x160.png",
                                    alt: "Fuerteventura",
                                    width: "270",
                                    height: "160",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.getOffersSelectedDestination
                                            .destinationOfferAptCode === "FUE",
                                        expression:
                                          "getOffersSelectedDestination.destinationOfferAptCode === 'FUE'",
                                      },
                                    ],
                                    staticClass: "discount",
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "discount-text" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.destinationwasclicked[
                                              _vm.getCurrentLocale
                                            ]
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "details" }, [
                            _c("h3", { staticClass: "box-title" }, [
                              _vm._v("Fuerteventura (FUE)"),
                              _c("small", [
                                _vm._v(_vm._s(_vm.spain[_vm.getCurrentLocale])),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "details",
                              staticStyle: { "margin-bottom": "50px" },
                            },
                            [
                              _vm.modulo === "booking"
                                ? _c("span", [
                                    _vm._m(2),
                                    _vm._v(" "),
                                    _vm.get_LowestPriceForKeyDes("FUE") !== 0
                                      ? _c("span", { staticClass: "price" }, [
                                          _c("small", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.from[_vm.getCurrentLocale]
                                              )
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "a",
                                            {
                                              directives: [
                                                {
                                                  name: "tooltip",
                                                  rawName: "v-tooltip",
                                                  value:
                                                    _vm.clicktoseebestprices[
                                                      _vm.getCurrentLocale
                                                    ],
                                                  expression:
                                                    "clicktoseebestprices[getCurrentLocale]",
                                                },
                                              ],
                                              attrs: { href: "#" },
                                              on: {
                                                click: function ($event) {
                                                  $event.preventDefault()
                                                  _vm.onClick_Destination("FUE")
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("rndAmntRUAFWZ")(
                                                    _vm.get_LowestPriceForKeyDes(
                                                      "FUE"
                                                    )
                                                  )
                                                ) +
                                                  "\n                                        "
                                              ),
                                            ]
                                          ),
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.get_LowestPriceForKeyDes("FUE") !== 0
                                      ? _c("h4", { staticClass: "box-title" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.flights[_vm.getCurrentLocale]
                                            )
                                          ),
                                          _c("small", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.offers[_vm.getCurrentLocale]
                                              )
                                            ),
                                          ]),
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.get_LowestPriceForKeyDes("FUE") === 0
                                      ? _c("span", { staticClass: "price" }, [
                                          _c("small", [_vm._v(" ")]),
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.get_LowestPriceForKeyDes("FUE") === 0
                                      ? _c("h4", { staticClass: "box-title" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.flights[_vm.getCurrentLocale]
                                            )
                                          ),
                                          _c("small", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.nooffers[
                                                  _vm.getCurrentLocale
                                                ]
                                              )
                                            ),
                                          ]),
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("hr"),
                                    _vm._v(" "),
                                    _vm._m(3),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "price" }, [
                                      _c("small", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.click[_vm.getCurrentLocale]
                                          )
                                        ),
                                      ]),
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: "https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&destination=fuerteventura&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=fuerteventura&etcc_ori=sundair_startseite_teaser",
                                            target: "_blank",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.here[_vm.getCurrentLocale]
                                            )
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("h4", { staticClass: "box-title" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.packagetours[_vm.getCurrentLocale]
                                        )
                                      ),
                                      _c("small", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.offers2[_vm.getCurrentLocale]
                                          )
                                        ),
                                      ]),
                                    ]),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.modulo === "flightplan"
                                ? _c("span", [
                                    _vm._m(4),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "price" }, [
                                      _c("small", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.click[_vm.getCurrentLocale]
                                          )
                                        ),
                                      ]),
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: "https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&destination=fuerteventura&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=fuerteventura&etcc_ori=sundair_startseite_teaser",
                                            target: "_blank",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.here[_vm.getCurrentLocale]
                                            )
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("h4", { staticClass: "box-title" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.packagetours[_vm.getCurrentLocale]
                                        )
                                      ),
                                      _c("small", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.offers2[_vm.getCurrentLocale]
                                          )
                                        ),
                                      ]),
                                    ]),
                                  ])
                                : _vm._e(),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("div", { staticStyle: { "margin-top": "4px" } }, [
                      _c(
                        "article",
                        {
                          staticClass: "box",
                          class: {
                            "has-discount":
                              _vm.getOffersSelectedDestination
                                .destinationOfferAptCode === "LPA",
                          },
                        },
                        [
                          _c("figure", [
                            _c(
                              "a",
                              {
                                staticClass: "hover-effect",
                                attrs: { href: "" },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    _vm.onClick_Destination("LPA")
                                  },
                                },
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: "/res/images/keydestinations/lpa_grancanaria_270x160.png",
                                    alt: "Gran Canaria",
                                    width: "270",
                                    height: "160",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.getOffersSelectedDestination
                                            .destinationOfferAptCode === "LPA",
                                        expression:
                                          "getOffersSelectedDestination.destinationOfferAptCode === 'LPA'",
                                      },
                                    ],
                                    staticClass: "discount",
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "discount-text" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.destinationwasclicked[
                                              _vm.getCurrentLocale
                                            ]
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "details" }, [
                            _c("h3", { staticClass: "box-title" }, [
                              _vm._v("Gran Canaria (LPA)"),
                              _c("small", [
                                _vm._v(_vm._s(_vm.spain[_vm.getCurrentLocale])),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "details",
                              staticStyle: { "margin-bottom": "50px" },
                            },
                            [
                              _vm.modulo === "booking"
                                ? _c("span", [
                                    _vm._m(5),
                                    _vm._v(" "),
                                    _vm.get_LowestPriceForKeyDes("LPA") !== 0
                                      ? _c("span", { staticClass: "price" }, [
                                          _c("small", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.from[_vm.getCurrentLocale]
                                              )
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "a",
                                            {
                                              directives: [
                                                {
                                                  name: "tooltip",
                                                  rawName: "v-tooltip",
                                                  value:
                                                    _vm.clicktoseebestprices[
                                                      _vm.getCurrentLocale
                                                    ],
                                                  expression:
                                                    "clicktoseebestprices[getCurrentLocale]",
                                                },
                                              ],
                                              attrs: { href: "#" },
                                              on: {
                                                click: function ($event) {
                                                  $event.preventDefault()
                                                  _vm.onClick_Destination("LPA")
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("rndAmntRUAFWZ")(
                                                    _vm.get_LowestPriceForKeyDes(
                                                      "LPA"
                                                    )
                                                  )
                                                ) +
                                                  "\n                                        "
                                              ),
                                            ]
                                          ),
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.get_LowestPriceForKeyDes("LPA") !== 0
                                      ? _c("h4", { staticClass: "box-title" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.flights[_vm.getCurrentLocale]
                                            )
                                          ),
                                          _c("small", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.offers[_vm.getCurrentLocale]
                                              )
                                            ),
                                          ]),
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.get_LowestPriceForKeyDes("LPA") === 0
                                      ? _c("span", { staticClass: "price" }, [
                                          _c("small", [_vm._v(" ")]),
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.get_LowestPriceForKeyDes("LPA") === 0
                                      ? _c("h4", { staticClass: "box-title" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.flights[_vm.getCurrentLocale]
                                            )
                                          ),
                                          _c("small", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.nooffers[
                                                  _vm.getCurrentLocale
                                                ]
                                              )
                                            ),
                                          ]),
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("hr"),
                                    _vm._v(" "),
                                    _vm._m(6),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "price" }, [
                                      _c("small", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.click[_vm.getCurrentLocale]
                                          )
                                        ),
                                      ]),
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: "https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&destination=gran_canaria&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=gran_canaria&etcc_ori=sundair_startseite_teaser",
                                            target: "_blank",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.here[_vm.getCurrentLocale]
                                            )
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("h4", { staticClass: "box-title" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.packagetours[_vm.getCurrentLocale]
                                        )
                                      ),
                                      _c("small", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.offers2[_vm.getCurrentLocale]
                                          )
                                        ),
                                      ]),
                                    ]),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.modulo === "flightplan"
                                ? _c("span", [
                                    _vm._m(7),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "price" }, [
                                      _c("small", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.click[_vm.getCurrentLocale]
                                          )
                                        ),
                                      ]),
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: "https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&destination=gran_canaria&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=gran_canaria&etcc_ori=sundair_startseite_teaser",
                                            target: "_blank",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.here[_vm.getCurrentLocale]
                                            )
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("h4", { staticClass: "box-title" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.packagetours[_vm.getCurrentLocale]
                                        )
                                      ),
                                      _c("small", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.offers2[_vm.getCurrentLocale]
                                          )
                                        ),
                                      ]),
                                    ]),
                                  ])
                                : _vm._e(),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("div", { staticStyle: { "margin-top": "4px" } }, [
                      _c(
                        "article",
                        {
                          staticClass: "box",
                          class: {
                            "has-discount":
                              _vm.getOffersSelectedDestination
                                .destinationOfferAptCode === "TFS",
                          },
                        },
                        [
                          _c("figure", [
                            _c(
                              "a",
                              {
                                staticClass: "hover-effect",
                                attrs: { href: "" },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    _vm.onClick_Destination("TFS")
                                  },
                                },
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: "/res/images/keydestinations/tfs_teneriffa_270x160.png",
                                    alt: "Teneriffa",
                                    width: "270",
                                    height: "160",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.getOffersSelectedDestination
                                            .destinationOfferAptCode === "TFS",
                                        expression:
                                          "getOffersSelectedDestination.destinationOfferAptCode === 'TFS'",
                                      },
                                    ],
                                    staticClass: "discount",
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "discount-text" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.destinationwasclicked[
                                              _vm.getCurrentLocale
                                            ]
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "details" }, [
                            _c("h3", { staticClass: "box-title" }, [
                              _vm._v("Teneriffa (TFS)"),
                              _c("small", [
                                _vm._v(_vm._s(_vm.spain[_vm.getCurrentLocale])),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "details",
                              staticStyle: { "margin-bottom": "50px" },
                            },
                            [
                              _vm.modulo === "booking"
                                ? _c("span", [
                                    _vm._m(8),
                                    _vm._v(" "),
                                    _vm.get_LowestPriceForKeyDes("TFS") !== 0
                                      ? _c("span", { staticClass: "price" }, [
                                          _c("small", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.from[_vm.getCurrentLocale]
                                              )
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "a",
                                            {
                                              directives: [
                                                {
                                                  name: "tooltip",
                                                  rawName: "v-tooltip",
                                                  value:
                                                    _vm.clicktoseebestprices[
                                                      _vm.getCurrentLocale
                                                    ],
                                                  expression:
                                                    "clicktoseebestprices[getCurrentLocale]",
                                                },
                                              ],
                                              attrs: { href: "#" },
                                              on: {
                                                click: function ($event) {
                                                  $event.preventDefault()
                                                  _vm.onClick_Destination("TFS")
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("rndAmntRUAFWZ")(
                                                    _vm.get_LowestPriceForKeyDes(
                                                      "TFS"
                                                    )
                                                  )
                                                ) +
                                                  "\n                                        "
                                              ),
                                            ]
                                          ),
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.get_LowestPriceForKeyDes("TFS") !== 0
                                      ? _c("h4", { staticClass: "box-title" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.flights[_vm.getCurrentLocale]
                                            )
                                          ),
                                          _c("small", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.offers[_vm.getCurrentLocale]
                                              )
                                            ),
                                          ]),
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.get_LowestPriceForKeyDes("TFS") === 0
                                      ? _c("span", { staticClass: "price" }, [
                                          _c("small", [_vm._v(" ")]),
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.get_LowestPriceForKeyDes("TFS") === 0
                                      ? _c("h4", { staticClass: "box-title" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.flights[_vm.getCurrentLocale]
                                            )
                                          ),
                                          _c("small", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.nooffers[
                                                  _vm.getCurrentLocale
                                                ]
                                              )
                                            ),
                                          ]),
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("hr"),
                                    _vm._v(" "),
                                    _vm._m(9),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "price" }, [
                                      _c("small", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.click[_vm.getCurrentLocale]
                                          )
                                        ),
                                      ]),
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: "https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&destination=teneriffa&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=teneriffa&etcc_ori=sundair_startseite_teaser",
                                            target: "_blank",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.here[_vm.getCurrentLocale]
                                            )
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("h4", { staticClass: "box-title" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.packagetours[_vm.getCurrentLocale]
                                        )
                                      ),
                                      _c("small", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.offers2[_vm.getCurrentLocale]
                                          )
                                        ),
                                      ]),
                                    ]),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.modulo === "flightplan"
                                ? _c("span", [
                                    _vm._m(10),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "price" }, [
                                      _c("small", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.click[_vm.getCurrentLocale]
                                          )
                                        ),
                                      ]),
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: "https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&destination=teneriffa&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=teneriffa&etcc_ori=sundair_startseite_teaser",
                                            target: "_blank",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.here[_vm.getCurrentLocale]
                                            )
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("h4", { staticClass: "box-title" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.packagetours[_vm.getCurrentLocale]
                                        )
                                      ),
                                      _c("small", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.offers2[_vm.getCurrentLocale]
                                          )
                                        ),
                                      ]),
                                    ]),
                                  ])
                                : _vm._e(),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("div", { staticStyle: { "margin-top": "4px" } }, [
                      _c(
                        "article",
                        {
                          staticClass: "box",
                          class: {
                            "has-discount":
                              _vm.getOffersSelectedDestination
                                .destinationOfferAptCode === "PMI",
                          },
                        },
                        [
                          _c("figure", [
                            _c(
                              "a",
                              {
                                staticClass: "hover-effect",
                                attrs: { href: "" },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    _vm.onClick_Destination("PMI")
                                  },
                                },
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: "/res/images/keydestinations/pmi_mallorca_270x160.png",
                                    alt: "Mallorca",
                                    width: "270",
                                    height: "160",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.getOffersSelectedDestination
                                            .destinationOfferAptCode === "PMI",
                                        expression:
                                          "getOffersSelectedDestination.destinationOfferAptCode === 'PMI'",
                                      },
                                    ],
                                    staticClass: "discount",
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "discount-text" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.destinationwasclicked[
                                              _vm.getCurrentLocale
                                            ]
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "details" }, [
                            _c("h3", { staticClass: "box-title" }, [
                              _vm._v("Mallorca (PMI)"),
                              _c("small", [
                                _vm._v(_vm._s(_vm.spain[_vm.getCurrentLocale])),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "details" }, [
                            _vm.modulo === "booking"
                              ? _c("span", [
                                  _vm._m(11),
                                  _vm._v(" "),
                                  _vm.get_LowestPriceForKeyDes("PMI") !== 0
                                    ? _c("span", { staticClass: "price" }, [
                                        _c("small", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.from[_vm.getCurrentLocale]
                                            )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          {
                                            directives: [
                                              {
                                                name: "tooltip",
                                                rawName: "v-tooltip",
                                                value:
                                                  _vm.clicktoseebestprices[
                                                    _vm.getCurrentLocale
                                                  ],
                                                expression:
                                                  "clicktoseebestprices[getCurrentLocale]",
                                              },
                                            ],
                                            attrs: { href: "#" },
                                            on: {
                                              click: function ($event) {
                                                $event.preventDefault()
                                                _vm.onClick_Destination("PMI")
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("rndAmntRUAFWZ")(
                                                  _vm.get_LowestPriceForKeyDes(
                                                    "PMI"
                                                  )
                                                )
                                              ) +
                                                "\n                                        "
                                            ),
                                          ]
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.get_LowestPriceForKeyDes("PMI") !== 0
                                    ? _c("h4", { staticClass: "box-title" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.flights[_vm.getCurrentLocale]
                                          )
                                        ),
                                        _c("small", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.offers[_vm.getCurrentLocale]
                                            )
                                          ),
                                        ]),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.get_LowestPriceForKeyDes("PMI") === 0
                                    ? _c("span", { staticClass: "price" }, [
                                        _c("small", [_vm._v(" ")]),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.get_LowestPriceForKeyDes("PMI") === 0
                                    ? _c("h4", { staticClass: "box-title" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.flights[_vm.getCurrentLocale]
                                          )
                                        ),
                                        _c("small", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.nooffers[_vm.getCurrentLocale]
                                            )
                                          ),
                                        ]),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("hr"),
                                  _vm._v(" "),
                                  _vm._m(12),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "price" }, [
                                    _c("small", [
                                      _vm._v(
                                        _vm._s(_vm.click[_vm.getCurrentLocale])
                                      ),
                                    ]),
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: "https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&date=20210401-20211031&destination=mallorca&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=mallorca&etcc_ori=sundair_startseite_teaser",
                                          target: "_blank",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.here[_vm.getCurrentLocale])
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("h4", { staticClass: "box-title" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.packagetours[_vm.getCurrentLocale]
                                      )
                                    ),
                                    _c("small", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.offers2[_vm.getCurrentLocale]
                                        )
                                      ),
                                    ]),
                                  ]),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.modulo === "flightplan"
                              ? _c("span", [
                                  _vm._m(13),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "price" }, [
                                    _c("small", [
                                      _vm._v(
                                        _vm._s(_vm.click[_vm.getCurrentLocale])
                                      ),
                                    ]),
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: "https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&date=20210401-20211031&destination=mallorca&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=mallorca&etcc_ori=sundair_startseite_teaser",
                                          target: "_blank",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.here[_vm.getCurrentLocale])
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("h4", { staticClass: "box-title" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.packagetours[_vm.getCurrentLocale]
                                      )
                                    ),
                                    _c("small", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.offers2[_vm.getCurrentLocale]
                                        )
                                      ),
                                    ]),
                                  ]),
                                ])
                              : _vm._e(),
                          ]),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("div", { staticStyle: { "margin-top": "4px" } }, [
                      _c(
                        "article",
                        {
                          staticClass: "box",
                          class: {
                            "has-discount":
                              _vm.getOffersSelectedDestination
                                .destinationOfferAptCode === "KGS",
                          },
                        },
                        [
                          _c("figure", [
                            _c(
                              "a",
                              {
                                staticClass: "hover-effect",
                                attrs: { href: "" },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    _vm.onClick_Destination("KGS")
                                  },
                                },
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: "/res/images/keydestinations/kos_kos_270x160.png",
                                    alt: "Kos",
                                    width: "270",
                                    height: "160",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.getOffersSelectedDestination
                                            .destinationOfferAptCode === "KGS",
                                        expression:
                                          "getOffersSelectedDestination.destinationOfferAptCode === 'KGS'",
                                      },
                                    ],
                                    staticClass: "discount",
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "discount-text" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.destinationwasclicked[
                                              _vm.getCurrentLocale
                                            ]
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "details" }, [
                            _c("h3", { staticClass: "box-title" }, [
                              _vm._v("Kos (KGS)"),
                              _c("small", [
                                _vm._v(
                                  _vm._s(_vm.greece[_vm.getCurrentLocale])
                                ),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "details" }, [
                            _vm.modulo === "booking"
                              ? _c("span", [
                                  _vm._m(14),
                                  _vm._v(" "),
                                  _vm.get_LowestPriceForKeyDes("KGS") !== 0
                                    ? _c("span", { staticClass: "price" }, [
                                        _c("small", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.from[_vm.getCurrentLocale]
                                            )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          {
                                            directives: [
                                              {
                                                name: "tooltip",
                                                rawName: "v-tooltip",
                                                value:
                                                  _vm.clicktoseebestprices[
                                                    _vm.getCurrentLocale
                                                  ],
                                                expression:
                                                  "clicktoseebestprices[getCurrentLocale]",
                                              },
                                            ],
                                            attrs: { href: "#" },
                                            on: {
                                              click: function ($event) {
                                                $event.preventDefault()
                                                _vm.onClick_Destination("KGS")
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("rndAmntRUAFWZ")(
                                                  _vm.get_LowestPriceForKeyDes(
                                                    "KGS"
                                                  )
                                                )
                                              ) +
                                                "\n                                        "
                                            ),
                                          ]
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.get_LowestPriceForKeyDes("KGS") !== 0
                                    ? _c("h4", { staticClass: "box-title" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.flights[_vm.getCurrentLocale]
                                          )
                                        ),
                                        _c("small", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.offers[_vm.getCurrentLocale]
                                            )
                                          ),
                                        ]),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.get_LowestPriceForKeyDes("KGS") === 0
                                    ? _c("span", { staticClass: "price" }, [
                                        _c("small", [_vm._v(" ")]),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.get_LowestPriceForKeyDes("KGS") === 0
                                    ? _c("h4", { staticClass: "box-title" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.flights[_vm.getCurrentLocale]
                                          )
                                        ),
                                        _c("small", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.nooffers[_vm.getCurrentLocale]
                                            )
                                          ),
                                        ]),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("hr"),
                                  _vm._v(" "),
                                  _vm._m(15),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "price" }, [
                                    _c("small", [
                                      _vm._v(
                                        _vm._s(_vm.click[_vm.getCurrentLocale])
                                      ),
                                    ]),
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: "https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&date=20210401-20211031&destination=kos&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=kos&etcc_ori=sundair_startseite_teaser",
                                          target: "_blank",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.here[_vm.getCurrentLocale])
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("h4", { staticClass: "box-title" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.packagetours[_vm.getCurrentLocale]
                                      )
                                    ),
                                    _c("small", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.offers2[_vm.getCurrentLocale]
                                        )
                                      ),
                                    ]),
                                  ]),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.modulo === "flightplan"
                              ? _c("span", [
                                  _vm._m(16),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "price" }, [
                                    _c("small", [
                                      _vm._v(
                                        _vm._s(_vm.click[_vm.getCurrentLocale])
                                      ),
                                    ]),
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: "https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&date=20210401-20211031&destination=kos&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=kos&etcc_ori=sundair_startseite_teaser",
                                          target: "_blank",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.here[_vm.getCurrentLocale])
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("h4", { staticClass: "box-title" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.packagetours[_vm.getCurrentLocale]
                                      )
                                    ),
                                    _c("small", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.offers2[_vm.getCurrentLocale]
                                        )
                                      ),
                                    ]),
                                  ]),
                                ])
                              : _vm._e(),
                          ]),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("div", { staticStyle: { "margin-top": "4px" } }, [
                      _c(
                        "article",
                        {
                          staticClass: "box",
                          class: {
                            "has-discount":
                              _vm.getOffersSelectedDestination
                                .destinationOfferAptCode === "CFU",
                          },
                        },
                        [
                          _c("figure", [
                            _c(
                              "a",
                              {
                                staticClass: "hover-effect",
                                attrs: { href: "" },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    _vm.onClick_Destination("CFU")
                                  },
                                },
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: "/res/images/keydestinations/cfu_corfu_270x160.png",
                                    alt: "Korfu",
                                    width: "270",
                                    height: "160",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.getOffersSelectedDestination
                                            .destinationOfferAptCode === "CFU",
                                        expression:
                                          "getOffersSelectedDestination.destinationOfferAptCode === 'CFU'",
                                      },
                                    ],
                                    staticClass: "discount",
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "discount-text" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.destinationwasclicked[
                                              _vm.getCurrentLocale
                                            ]
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "details" }, [
                            _c("h3", { staticClass: "box-title" }, [
                              _vm._v("Korfu (CFU)"),
                              _c("small", [
                                _vm._v(
                                  _vm._s(_vm.greece[_vm.getCurrentLocale])
                                ),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "details" }, [
                            _vm.modulo === "booking"
                              ? _c("span", [
                                  _vm._m(17),
                                  _vm._v(" "),
                                  _vm.get_LowestPriceForKeyDes("CFU") !== 0
                                    ? _c("span", { staticClass: "price" }, [
                                        _c("small", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.from[_vm.getCurrentLocale]
                                            )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          {
                                            directives: [
                                              {
                                                name: "tooltip",
                                                rawName: "v-tooltip",
                                                value:
                                                  _vm.clicktoseebestprices[
                                                    _vm.getCurrentLocale
                                                  ],
                                                expression:
                                                  "clicktoseebestprices[getCurrentLocale]",
                                              },
                                            ],
                                            attrs: { href: "#" },
                                            on: {
                                              click: function ($event) {
                                                $event.preventDefault()
                                                _vm.onClick_Destination("CFU")
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("rndAmntRUAFWZ")(
                                                  _vm.get_LowestPriceForKeyDes(
                                                    "CFU"
                                                  )
                                                )
                                              ) +
                                                "\n                                        "
                                            ),
                                          ]
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.get_LowestPriceForKeyDes("CFU") !== 0
                                    ? _c("h4", { staticClass: "box-title" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.flights[_vm.getCurrentLocale]
                                          )
                                        ),
                                        _c("small", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.offers[_vm.getCurrentLocale]
                                            )
                                          ),
                                        ]),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.get_LowestPriceForKeyDes("CFU") === 0
                                    ? _c("span", { staticClass: "price" }, [
                                        _c("small", [_vm._v(" ")]),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.get_LowestPriceForKeyDes("CFU") === 0
                                    ? _c("h4", { staticClass: "box-title" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.flights[_vm.getCurrentLocale]
                                          )
                                        ),
                                        _c("small", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.nooffers[_vm.getCurrentLocale]
                                            )
                                          ),
                                        ]),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("hr"),
                                  _vm._v(" "),
                                  _vm._m(18),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "price" }, [
                                    _c("small", [
                                      _vm._v(
                                        _vm._s(_vm.click[_vm.getCurrentLocale])
                                      ),
                                    ]),
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: "https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&date=20210401-20211031&destination=korfu_paxi&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=Korfu&etcc_ori=sundair_startseite_teaser",
                                          target: "_blank",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.here[_vm.getCurrentLocale])
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("h4", { staticClass: "box-title" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.packagetours[_vm.getCurrentLocale]
                                      )
                                    ),
                                    _c("small", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.offers2[_vm.getCurrentLocale]
                                        )
                                      ),
                                    ]),
                                  ]),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.modulo === "flightplan"
                              ? _c("span", [
                                  _vm._m(19),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "price" }, [
                                    _c("small", [
                                      _vm._v(
                                        _vm._s(_vm.click[_vm.getCurrentLocale])
                                      ),
                                    ]),
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: "https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&date=20210401-20211031&destination=korfu_paxi&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=Korfu&etcc_ori=sundair_startseite_teaser",
                                          target: "_blank",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.here[_vm.getCurrentLocale])
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("h4", { staticClass: "box-title" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.packagetours[_vm.getCurrentLocale]
                                      )
                                    ),
                                    _c("small", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.offers2[_vm.getCurrentLocale]
                                        )
                                      ),
                                    ]),
                                  ]),
                                ])
                              : _vm._e(),
                          ]),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("div", { staticStyle: { "margin-top": "4px" } }, [
                      _c(
                        "article",
                        {
                          staticClass: "box",
                          class: {
                            "has-discount":
                              _vm.getOffersSelectedDestination
                                .destinationOfferAptCode === "HER",
                          },
                        },
                        [
                          _c("figure", [
                            _c(
                              "a",
                              {
                                staticClass: "hover-effect",
                                attrs: { href: "" },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    _vm.onClick_Destination("HER")
                                  },
                                },
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: "/res/images/keydestinations/her_heraklion_270x160.png",
                                    alt: "Heraklion",
                                    width: "270",
                                    height: "160",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.getOffersSelectedDestination
                                            .destinationOfferAptCode === "HER",
                                        expression:
                                          "getOffersSelectedDestination.destinationOfferAptCode === 'HER'",
                                      },
                                    ],
                                    staticClass: "discount",
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "discount-text" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.destinationwasclicked[
                                              _vm.getCurrentLocale
                                            ]
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "details" }, [
                            _c("h3", { staticClass: "box-title" }, [
                              _vm._v("Heraklion (HER)"),
                              _c("small", [
                                _vm._v(
                                  _vm._s(_vm.greece[_vm.getCurrentLocale])
                                ),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "details" }, [
                            _vm.modulo === "booking"
                              ? _c("span", [
                                  _vm._m(20),
                                  _vm._v(" "),
                                  _vm.get_LowestPriceForKeyDes("HER") !== 0
                                    ? _c("span", { staticClass: "price" }, [
                                        _c("small", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.from[_vm.getCurrentLocale]
                                            )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          {
                                            directives: [
                                              {
                                                name: "tooltip",
                                                rawName: "v-tooltip",
                                                value:
                                                  _vm.clicktoseebestprices[
                                                    _vm.getCurrentLocale
                                                  ],
                                                expression:
                                                  "clicktoseebestprices[getCurrentLocale]",
                                              },
                                            ],
                                            attrs: { href: "#" },
                                            on: {
                                              click: function ($event) {
                                                $event.preventDefault()
                                                _vm.onClick_Destination("HER")
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("rndAmntRUAFWZ")(
                                                  _vm.get_LowestPriceForKeyDes(
                                                    "HER"
                                                  )
                                                )
                                              ) +
                                                "\n                                        "
                                            ),
                                          ]
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.get_LowestPriceForKeyDes("HER") !== 0
                                    ? _c("h4", { staticClass: "box-title" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.flights[_vm.getCurrentLocale]
                                          )
                                        ),
                                        _c("small", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.offers[_vm.getCurrentLocale]
                                            )
                                          ),
                                        ]),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.get_LowestPriceForKeyDes("HER") === 0
                                    ? _c("span", { staticClass: "price" }, [
                                        _c("small", [_vm._v(" ")]),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.get_LowestPriceForKeyDes("HER") === 0
                                    ? _c("h4", { staticClass: "box-title" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.flights[_vm.getCurrentLocale]
                                          )
                                        ),
                                        _c("small", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.nooffers[_vm.getCurrentLocale]
                                            )
                                          ),
                                        ]),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("hr"),
                                  _vm._v(" "),
                                  _vm._m(21),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "price" }, [
                                    _c("small", [
                                      _vm._v(
                                        _vm._s(_vm.click[_vm.getCurrentLocale])
                                      ),
                                    ]),
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: "https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&date=20210401-20211031&destination=kreta&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=kreta&etcc_ori=sundair_startseite_teaser",
                                          target: "_blank",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.here[_vm.getCurrentLocale])
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("h4", { staticClass: "box-title" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.packagetours[_vm.getCurrentLocale]
                                      )
                                    ),
                                    _c("small", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.offers2[_vm.getCurrentLocale]
                                        )
                                      ),
                                    ]),
                                  ]),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.modulo === "flightplan"
                              ? _c("span", [
                                  _vm._m(22),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "price" }, [
                                    _c("small", [
                                      _vm._v(
                                        _vm._s(_vm.click[_vm.getCurrentLocale])
                                      ),
                                    ]),
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: "https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&date=20210401-20211031&destination=kreta&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=kreta&etcc_ori=sundair_startseite_teaser",
                                          target: "_blank",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.here[_vm.getCurrentLocale])
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("h4", { staticClass: "box-title" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.packagetours[_vm.getCurrentLocale]
                                      )
                                    ),
                                    _c("small", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.offers2[_vm.getCurrentLocale]
                                        )
                                      ),
                                    ]),
                                  ]),
                                ])
                              : _vm._e(),
                          ]),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("div", { staticStyle: { "margin-top": "4px" } }, [
                      _c(
                        "article",
                        {
                          staticClass: "box",
                          class: {
                            "has-discount":
                              _vm.getOffersSelectedDestination
                                .destinationOfferAptCode === "RHO",
                          },
                        },
                        [
                          _c("figure", [
                            _c(
                              "a",
                              {
                                staticClass: "hover-effect",
                                attrs: { href: "" },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    _vm.onClick_Destination("RHO")
                                  },
                                },
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: "/res/images/keydestinations/rho_rhodos_270x160.png",
                                    alt: "Rhodos",
                                    width: "270",
                                    height: "160",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.getOffersSelectedDestination
                                            .destinationOfferAptCode === "RHO",
                                        expression:
                                          "getOffersSelectedDestination.destinationOfferAptCode === 'RHO'",
                                      },
                                    ],
                                    staticClass: "discount",
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "discount-text" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.destinationwasclicked[
                                              _vm.getCurrentLocale
                                            ]
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "details" }, [
                            _c("h3", { staticClass: "box-title" }, [
                              _vm._v("Rhodos (RHO)"),
                              _c("small", [
                                _vm._v(
                                  _vm._s(_vm.greece[_vm.getCurrentLocale])
                                ),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "details" }, [
                            _vm.modulo === "booking"
                              ? _c("span", [
                                  _vm._m(23),
                                  _vm._v(" "),
                                  _vm.get_LowestPriceForKeyDes("RHO") !== 0
                                    ? _c("span", { staticClass: "price" }, [
                                        _c("small", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.from[_vm.getCurrentLocale]
                                            )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          {
                                            directives: [
                                              {
                                                name: "tooltip",
                                                rawName: "v-tooltip",
                                                value:
                                                  _vm.clicktoseebestprices[
                                                    _vm.getCurrentLocale
                                                  ],
                                                expression:
                                                  "clicktoseebestprices[getCurrentLocale]",
                                              },
                                            ],
                                            attrs: { href: "#" },
                                            on: {
                                              click: function ($event) {
                                                $event.preventDefault()
                                                _vm.onClick_Destination("RHO")
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("rndAmntRUAFWZ")(
                                                  _vm.get_LowestPriceForKeyDes(
                                                    "RHO"
                                                  )
                                                )
                                              ) +
                                                "\n                                        "
                                            ),
                                          ]
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.get_LowestPriceForKeyDes("RHO") !== 0
                                    ? _c("h4", { staticClass: "box-title" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.flights[_vm.getCurrentLocale]
                                          )
                                        ),
                                        _c("small", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.offers[_vm.getCurrentLocale]
                                            )
                                          ),
                                        ]),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.get_LowestPriceForKeyDes("RHO") === 0
                                    ? _c("span", { staticClass: "price" }, [
                                        _c("small", [_vm._v(" ")]),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.get_LowestPriceForKeyDes("RHO") === 0
                                    ? _c("h4", { staticClass: "box-title" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.flights[_vm.getCurrentLocale]
                                          )
                                        ),
                                        _c("small", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.nooffers[_vm.getCurrentLocale]
                                            )
                                          ),
                                        ]),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("hr"),
                                  _vm._v(" "),
                                  _vm._m(24),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "price" }, [
                                    _c("small", [
                                      _vm._v(
                                        _vm._s(_vm.click[_vm.getCurrentLocale])
                                      ),
                                    ]),
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: "https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&date=20210401-20211031&destination=rhodos&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=rhodos&etcc_ori=sundair_startseite_teaser",
                                          target: "_blank",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.here[_vm.getCurrentLocale])
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("h4", { staticClass: "box-title" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.packagetours[_vm.getCurrentLocale]
                                      )
                                    ),
                                    _c("small", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.offers2[_vm.getCurrentLocale]
                                        )
                                      ),
                                    ]),
                                  ]),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.modulo === "flightplan"
                              ? _c("span", [
                                  _vm._m(25),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "price" }, [
                                    _c("small", [
                                      _vm._v(
                                        _vm._s(_vm.click[_vm.getCurrentLocale])
                                      ),
                                    ]),
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: "https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&date=20210401-20211031&destination=rhodos&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=rhodos&etcc_ori=sundair_startseite_teaser",
                                          target: "_blank",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.here[_vm.getCurrentLocale])
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("h4", { staticClass: "box-title" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.packagetours[_vm.getCurrentLocale]
                                      )
                                    ),
                                    _c("small", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.offers2[_vm.getCurrentLocale]
                                        )
                                      ),
                                    ]),
                                  ]),
                                ])
                              : _vm._e(),
                          ]),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("div", { staticStyle: { "margin-top": "4px" } }, [
                      _c(
                        "article",
                        {
                          staticClass: "box",
                          class: {
                            "has-discount":
                              _vm.getOffersSelectedDestination
                                .destinationOfferAptCode === "BOJ",
                          },
                        },
                        [
                          _c("figure", [
                            _c(
                              "a",
                              {
                                staticClass: "hover-effect",
                                attrs: { href: "" },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    _vm.onClick_Destination("BOJ")
                                  },
                                },
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: "/res/images/keydestinations/boj_burgas_270x160.png",
                                    alt: "Burgas",
                                    width: "270",
                                    height: "160",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.getOffersSelectedDestination
                                            .destinationOfferAptCode === "BOJ",
                                        expression:
                                          "getOffersSelectedDestination.destinationOfferAptCode === 'BOJ'",
                                      },
                                    ],
                                    staticClass: "discount",
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "discount-text" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.destinationwasclicked[
                                              _vm.getCurrentLocale
                                            ]
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "details" }, [
                            _c("h3", { staticClass: "box-title" }, [
                              _vm._v("Burgas (BOJ)"),
                              _c("small", [
                                _vm._v(
                                  _vm._s(_vm.bulgary[_vm.getCurrentLocale])
                                ),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "details" }, [
                            _vm.modulo === "booking"
                              ? _c("span", [
                                  _vm._m(26),
                                  _vm._v(" "),
                                  _vm.get_LowestPriceForKeyDes("BOJ") !== 0
                                    ? _c("span", { staticClass: "price" }, [
                                        _c("small", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.from[_vm.getCurrentLocale]
                                            )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          {
                                            directives: [
                                              {
                                                name: "tooltip",
                                                rawName: "v-tooltip",
                                                value:
                                                  _vm.clicktoseebestprices[
                                                    _vm.getCurrentLocale
                                                  ],
                                                expression:
                                                  "clicktoseebestprices[getCurrentLocale]",
                                              },
                                            ],
                                            attrs: { href: "#" },
                                            on: {
                                              click: function ($event) {
                                                $event.preventDefault()
                                                _vm.onClick_Destination("BOJ")
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("rndAmntRUAFWZ")(
                                                  _vm.get_LowestPriceForKeyDes(
                                                    "BOJ"
                                                  )
                                                )
                                              ) +
                                                "\n                                        "
                                            ),
                                          ]
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.get_LowestPriceForKeyDes("BOJ") !== 0
                                    ? _c("h4", { staticClass: "box-title" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.flights[_vm.getCurrentLocale]
                                          )
                                        ),
                                        _c("small", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.offers[_vm.getCurrentLocale]
                                            )
                                          ),
                                        ]),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.get_LowestPriceForKeyDes("BOJ") === 0
                                    ? _c("span", { staticClass: "price" }, [
                                        _c("small", [_vm._v(" ")]),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.get_LowestPriceForKeyDes("BOJ") === 0
                                    ? _c("h4", { staticClass: "box-title" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.flights[_vm.getCurrentLocale]
                                          )
                                        ),
                                        _c("small", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.nooffers[_vm.getCurrentLocale]
                                            )
                                          ),
                                        ]),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("hr"),
                                  _vm._v(" "),
                                  _vm._m(27),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "price" }, [
                                    _c("small", [
                                      _vm._v(
                                        _vm._s(_vm.click[_vm.getCurrentLocale])
                                      ),
                                    ]),
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: "https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&date=20210401-20211031&destination=bulgarien_albena_umgebung-bulgarien_goldstrand_varna-bulgarien_sonnenstrand_burgas_nessebar&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=bulgarien&etcc_ori=sundair_startseite_teaser",
                                          target: "_blank",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.here[_vm.getCurrentLocale])
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("h4", { staticClass: "box-title" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.packagetours[_vm.getCurrentLocale]
                                      )
                                    ),
                                    _c("small", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.offers2[_vm.getCurrentLocale]
                                        )
                                      ),
                                    ]),
                                  ]),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.modulo === "flightplan"
                              ? _c("span", [
                                  _vm._m(28),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "price" }, [
                                    _c("small", [
                                      _vm._v(
                                        _vm._s(_vm.click[_vm.getCurrentLocale])
                                      ),
                                    ]),
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: "https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&date=20210401-20211031&destination=bulgarien_albena_umgebung-bulgarien_goldstrand_varna-bulgarien_sonnenstrand_burgas_nessebar&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=bulgarien&etcc_ori=sundair_startseite_teaser",
                                          target: "_blank",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.here[_vm.getCurrentLocale])
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("h4", { staticClass: "box-title" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.packagetours[_vm.getCurrentLocale]
                                      )
                                    ),
                                    _c("small", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.offers2[_vm.getCurrentLocale]
                                        )
                                      ),
                                    ]),
                                  ]),
                                ])
                              : _vm._e(),
                          ]),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("div", { staticStyle: { "margin-top": "4px" } }, [
                      _c(
                        "article",
                        {
                          staticClass: "box",
                          class: {
                            "has-discount":
                              _vm.getOffersSelectedDestination
                                .destinationOfferAptCode === "AYT",
                          },
                        },
                        [
                          _c("figure", [
                            _c(
                              "a",
                              {
                                staticClass: "hover-effect",
                                attrs: { href: "" },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    _vm.onClick_Destination("AYT")
                                  },
                                },
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: "/res/images/keydestinations/ayt_antalya_270x160.png",
                                    alt: "Antalya",
                                    width: "270",
                                    height: "160",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.getOffersSelectedDestination
                                            .destinationOfferAptCode === "AYT",
                                        expression:
                                          "getOffersSelectedDestination.destinationOfferAptCode === 'AYT'",
                                      },
                                    ],
                                    staticClass: "discount",
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "discount-text" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.destinationwasclicked[
                                              _vm.getCurrentLocale
                                            ]
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "details" }, [
                            _c("h3", { staticClass: "box-title" }, [
                              _vm._v("Antalya (AYT)"),
                              _c("small", [
                                _vm._v(
                                  _vm._s(_vm.turkey[_vm.getCurrentLocale])
                                ),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "details" }, [
                            _vm.modulo === "booking"
                              ? _c("span", [
                                  _vm._m(29),
                                  _vm._v(" "),
                                  _vm.get_LowestPriceForKeyDes("AYT") !== 0
                                    ? _c("span", { staticClass: "price" }, [
                                        _c("small", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.from[_vm.getCurrentLocale]
                                            )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          {
                                            directives: [
                                              {
                                                name: "tooltip",
                                                rawName: "v-tooltip",
                                                value:
                                                  _vm.clicktoseebestprices[
                                                    _vm.getCurrentLocale
                                                  ],
                                                expression:
                                                  "clicktoseebestprices[getCurrentLocale]",
                                              },
                                            ],
                                            attrs: { href: "#" },
                                            on: {
                                              click: function ($event) {
                                                $event.preventDefault()
                                                _vm.onClick_Destination("AYT")
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("rndAmntRUAFWZ")(
                                                  _vm.get_LowestPriceForKeyDes(
                                                    "AYT"
                                                  )
                                                )
                                              ) +
                                                "\n                                        "
                                            ),
                                          ]
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.get_LowestPriceForKeyDes("AYT") !== 0
                                    ? _c("h4", { staticClass: "box-title" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.flights[_vm.getCurrentLocale]
                                          )
                                        ),
                                        _c("small", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.offers[_vm.getCurrentLocale]
                                            )
                                          ),
                                        ]),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.get_LowestPriceForKeyDes("AYT") === 0
                                    ? _c("span", { staticClass: "price" }, [
                                        _c("small", [_vm._v(" ")]),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.get_LowestPriceForKeyDes("AYT") === 0
                                    ? _c("h4", { staticClass: "box-title" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.flights[_vm.getCurrentLocale]
                                          )
                                        ),
                                        _c("small", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.nooffers[_vm.getCurrentLocale]
                                            )
                                          ),
                                        ]),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("hr"),
                                  _vm._v(" "),
                                  _vm._m(30),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "price" }, [
                                    _c("small", [
                                      _vm._v(
                                        _vm._s(_vm.click[_vm.getCurrentLocale])
                                      ),
                                    ]),
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: "https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&destination=tuerkei&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=tuerkei&etcc_ori=sundair_startseite_teaser",
                                          target: "_blank",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.here[_vm.getCurrentLocale])
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("h4", { staticClass: "box-title" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.packagetours[_vm.getCurrentLocale]
                                      )
                                    ),
                                    _c("small", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.offers2[_vm.getCurrentLocale]
                                        )
                                      ),
                                    ]),
                                  ]),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.modulo === "flightplan"
                              ? _c("span", [
                                  _vm._m(31),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "price" }, [
                                    _c("small", [
                                      _vm._v(
                                        _vm._s(_vm.click[_vm.getCurrentLocale])
                                      ),
                                    ]),
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: "https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&destination=tuerkei&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=tuerkei&etcc_ori=sundair_startseite_teaser",
                                          target: "_blank",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.here[_vm.getCurrentLocale])
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("h4", { staticClass: "box-title" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.packagetours[_vm.getCurrentLocale]
                                      )
                                    ),
                                    _c("small", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.offers2[_vm.getCurrentLocale]
                                        )
                                      ),
                                    ]),
                                  ]),
                                ])
                              : _vm._e(),
                          ]),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("div", { staticStyle: { "margin-top": "4px" } }, [
                      _c(
                        "article",
                        {
                          staticClass: "box",
                          class: {
                            "has-discount":
                              _vm.getOffersSelectedDestination
                                .destinationOfferAptCode === "HRG",
                          },
                        },
                        [
                          _c("figure", [
                            _c(
                              "a",
                              {
                                staticClass: "hover-effect",
                                attrs: { href: "" },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    _vm.onClick_Destination("HRG")
                                  },
                                },
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: "/res/images/keydestinations/hrg_hurghada_270x160.png",
                                    alt: "Hurghada",
                                    width: "270",
                                    height: "160",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.getOffersSelectedDestination
                                            .destinationOfferAptCode === "HRG",
                                        expression:
                                          "getOffersSelectedDestination.destinationOfferAptCode === 'HRG'",
                                      },
                                    ],
                                    staticClass: "discount",
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "discount-text" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.destinationwasclicked[
                                              _vm.getCurrentLocale
                                            ]
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "details" }, [
                            _c("h3", { staticClass: "box-title" }, [
                              _vm._v("Hurghada (HRG)"),
                              _c("small", [
                                _vm._v(_vm._s(_vm.egypt[_vm.getCurrentLocale])),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "details" }, [
                            _vm.modulo === "booking"
                              ? _c("span", [
                                  _vm._m(32),
                                  _vm._v(" "),
                                  _vm.get_LowestPriceForKeyDes("HRG") !== 0
                                    ? _c("span", { staticClass: "price" }, [
                                        _c("small", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.from[_vm.getCurrentLocale]
                                            )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          {
                                            directives: [
                                              {
                                                name: "tooltip",
                                                rawName: "v-tooltip",
                                                value:
                                                  _vm.clicktoseebestprices[
                                                    _vm.getCurrentLocale
                                                  ],
                                                expression:
                                                  "clicktoseebestprices[getCurrentLocale]",
                                              },
                                            ],
                                            attrs: { href: "#" },
                                            on: {
                                              click: function ($event) {
                                                $event.preventDefault()
                                                _vm.onClick_Destination("HRG")
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("rndAmntRUAFWZ")(
                                                  _vm.get_LowestPriceForKeyDes(
                                                    "HRG"
                                                  )
                                                )
                                              ) +
                                                "\n                                        "
                                            ),
                                          ]
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.get_LowestPriceForKeyDes("HRG") !== 0
                                    ? _c("h4", { staticClass: "box-title" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.flights[_vm.getCurrentLocale]
                                          )
                                        ),
                                        _c("small", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.offers[_vm.getCurrentLocale]
                                            )
                                          ),
                                        ]),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.get_LowestPriceForKeyDes("HRG") === 0
                                    ? _c("span", { staticClass: "price" }, [
                                        _c("small", [_vm._v(" ")]),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.get_LowestPriceForKeyDes("HRG") === 0
                                    ? _c("h4", { staticClass: "box-title" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.flights[_vm.getCurrentLocale]
                                          )
                                        ),
                                        _c("small", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.nooffers[_vm.getCurrentLocale]
                                            )
                                          ),
                                        ]),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("hr"),
                                  _vm._v(" "),
                                  _vm._m(33),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "price" }, [
                                    _c("small", [
                                      _vm._v(
                                        _vm._s(_vm.click[_vm.getCurrentLocale])
                                      ),
                                    ]),
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: "https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&destination=hurghada_safaga&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=hurghada_safaga&etcc_ori=sundair_startseite_teaser",
                                          target: "_blank",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.here[_vm.getCurrentLocale])
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("h4", { staticClass: "box-title" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.packagetours[_vm.getCurrentLocale]
                                      )
                                    ),
                                    _c("small", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.offers2[_vm.getCurrentLocale]
                                        )
                                      ),
                                    ]),
                                  ]),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.modulo === "flightplan"
                              ? _c("span", [
                                  _vm._m(34),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "price" }, [
                                    _c("small", [
                                      _vm._v(
                                        _vm._s(_vm.click[_vm.getCurrentLocale])
                                      ),
                                    ]),
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: "https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&destination=hurghada_safaga&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=hurghada_safaga&etcc_ori=sundair_startseite_teaser",
                                          target: "_blank",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.here[_vm.getCurrentLocale])
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("h4", { staticClass: "box-title" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.packagetours[_vm.getCurrentLocale]
                                      )
                                    ),
                                    _c("small", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.offers2[_vm.getCurrentLocale]
                                        )
                                      ),
                                    ]),
                                  ]),
                                ])
                              : _vm._e(),
                          ]),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("div", { staticStyle: { "margin-top": "4px" } }, [
                      _c(
                        "article",
                        {
                          staticClass: "box",
                          class: {
                            "has-discount":
                              _vm.getOffersSelectedDestination
                                .destinationOfferAptCode === "VAR",
                          },
                        },
                        [
                          _c("figure", [
                            _c(
                              "a",
                              {
                                staticClass: "hover-effect",
                                attrs: { href: "" },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    _vm.onClick_Destination("VAR")
                                  },
                                },
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: "/res/images/keydestinations/var_varna_270x160.png",
                                    alt: "Varna",
                                    width: "270",
                                    height: "160",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.getOffersSelectedDestination
                                            .destinationOfferAptCode === "VAR",
                                        expression:
                                          "getOffersSelectedDestination.destinationOfferAptCode === 'VAR'",
                                      },
                                    ],
                                    staticClass: "discount",
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "discount-text" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.destinationwasclicked[
                                              _vm.getCurrentLocale
                                            ]
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "details" }, [
                            _c("h3", { staticClass: "box-title" }, [
                              _vm._v("Varna (VAR)"),
                              _c("small", [
                                _vm._v(
                                  _vm._s(_vm.bulgary[_vm.getCurrentLocale])
                                ),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "details" }, [
                            _vm.modulo === "booking"
                              ? _c("span", [
                                  _vm._m(35),
                                  _vm._v(" "),
                                  _vm.get_LowestPriceForKeyDes("VAR") !== 0
                                    ? _c("span", { staticClass: "price" }, [
                                        _c("small", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.from[_vm.getCurrentLocale]
                                            )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          {
                                            directives: [
                                              {
                                                name: "tooltip",
                                                rawName: "v-tooltip",
                                                value:
                                                  _vm.clicktoseebestprices[
                                                    _vm.getCurrentLocale
                                                  ],
                                                expression:
                                                  "clicktoseebestprices[getCurrentLocale]",
                                              },
                                            ],
                                            attrs: { href: "#" },
                                            on: {
                                              click: function ($event) {
                                                $event.preventDefault()
                                                _vm.onClick_Destination("VAR")
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("rndAmntRUAFWZ")(
                                                  _vm.get_LowestPriceForKeyDes(
                                                    "VAR"
                                                  )
                                                )
                                              ) +
                                                "\n                                        "
                                            ),
                                          ]
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.get_LowestPriceForKeyDes("VAR") !== 0
                                    ? _c("h4", { staticClass: "box-title" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.flights[_vm.getCurrentLocale]
                                          )
                                        ),
                                        _c("small", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.offers[_vm.getCurrentLocale]
                                            )
                                          ),
                                        ]),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.get_LowestPriceForKeyDes("VAR") === 0
                                    ? _c("span", { staticClass: "price" }, [
                                        _c("small", [_vm._v(" ")]),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.get_LowestPriceForKeyDes("VAR") === 0
                                    ? _c("h4", { staticClass: "box-title" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.flights[_vm.getCurrentLocale]
                                          )
                                        ),
                                        _c("small", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.nooffers[_vm.getCurrentLocale]
                                            )
                                          ),
                                        ]),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("hr"),
                                  _vm._v(" "),
                                  _vm._m(36),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "price" }, [
                                    _c("small", [
                                      _vm._v(
                                        _vm._s(_vm.click[_vm.getCurrentLocale])
                                      ),
                                    ]),
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: "https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&date=20210401-20211031&destination=bulgarien_albena_umgebung-bulgarien_goldstrand_varna-bulgarien_sonnenstrand_burgas_nessebar&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=bulgarien&etcc_ori=sundair_startseite_teaser",
                                          target: "_blank",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.here[_vm.getCurrentLocale])
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("h4", { staticClass: "box-title" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.packagetours[_vm.getCurrentLocale]
                                      )
                                    ),
                                    _c("small", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.offers2[_vm.getCurrentLocale]
                                        )
                                      ),
                                    ]),
                                  ]),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.modulo === "flightplan"
                              ? _c("span", [
                                  _vm._m(37),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "price" }, [
                                    _c("small", [
                                      _vm._v(
                                        _vm._s(_vm.click[_vm.getCurrentLocale])
                                      ),
                                    ]),
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: "https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&date=20210401-20211031&destination=bulgarien_albena_umgebung-bulgarien_goldstrand_varna-bulgarien_sonnenstrand_burgas_nessebar&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=bulgarien&etcc_ori=sundair_startseite_teaser",
                                          target: "_blank",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.here[_vm.getCurrentLocale])
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("h4", { staticClass: "box-title" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.packagetours[_vm.getCurrentLocale]
                                      )
                                    ),
                                    _c("small", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.offers2[_vm.getCurrentLocale]
                                        )
                                      ),
                                    ]),
                                  ]),
                                ])
                              : _vm._e(),
                          ]),
                        ]
                      ),
                    ]),
                  ]),
                ]),
              ]
            ),
            _vm._v(" "),
            _vm.getOffersSelectedDestination.price !== undefined
              ? _c("span", { staticClass: "text-small pull-left" }, [
                  _c(
                    "a",
                    {
                      attrs: { href: "#" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.onClick_Reset_KeyDestinations($event)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.reset[_vm.getCurrentLocale]))]
                  ),
                ])
              : _vm._e(),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _vm.getOffersSelectedDestination.price !== undefined
        ? _c(
            "div",
            {
              staticClass: "container block image-container animated fadeIn",
              staticStyle: {
                "animation-duration": "3s",
                visibility: "visible",
              },
              attrs: {
                "data-animation-type": "fadeIn",
                "data-animation-duration": "3",
              },
            },
            [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12", attrs: { id: "main" } }, [
                  _c("div", { staticClass: "cruise-list" }, [
                    _c("div", { staticClass: "listing-style3 cruise" }, [
                      _c("article", { staticClass: "box" }, [
                        _c(
                          "figure",
                          {
                            staticClass: "details col-sm-3",
                            staticStyle: { "margin-top": "7px" },
                          },
                          [
                            _c("a", {}, [
                              _c("img", {
                                attrs: {
                                  width: "270",
                                  height: "160",
                                  alt: "",
                                  src:
                                    "/res/images/keydestinations/" +
                                    _vm.getOffersSelectedDestination.destinationOfferAptCode.toLowerCase() +
                                    ".png",
                                },
                              }),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            key: _vm.fakeCounter,
                            staticClass: "details col-sm-9",
                          },
                          [
                            _c("div", { staticClass: "clearfix" }, [
                              _c("div", { staticClass: "row" }, [
                                _c(
                                  "div",
                                  { staticClass: "col-xs-6 col-md-6" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "selector",
                                        staticStyle: { "text-align": "end" },
                                      },
                                      [
                                        _c(
                                          "label",
                                          { staticClass: "smallSelectorDescs" },
                                          [_vm._v(" ")]
                                        ),
                                        _vm._v(" "),
                                        _c("v-select", {
                                          key: "i",
                                          ref: "depArprtCodeKeyDes",
                                          staticClass: "style-chooser",
                                          class: {
                                            buttonglowing:
                                              _vm.getBookingOffersListFlightsMonthlyOffers.reduce(
                                                function (a, b) {
                                                  return a + b
                                                },
                                                0
                                              ) === 0,
                                          },
                                          staticStyle: {
                                            "margin-bottom": "20px",
                                          },
                                          attrs: {
                                            name: "depArprtCodeKeyDes",
                                            clearable: false,
                                            options:
                                              _vm.getBookingDeparturesKeyDes,
                                            label: "l",
                                            value: _vm.i,
                                            placeholder:
                                              this.departureairport[
                                                this.getCurrentLocale
                                              ],
                                          },
                                          on: {
                                            input:
                                              _vm.onSelect_DepartureAirportKeyDes,
                                          },
                                          model: {
                                            value: _vm.depArprtCodeKeyDes,
                                            callback: function ($$v) {
                                              _vm.depArprtCodeKeyDes = $$v
                                            },
                                            expression: "depArprtCodeKeyDes",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-xs-2 col-md-2" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "selector",
                                        staticStyle: { "text-align": "end" },
                                      },
                                      [
                                        _c(
                                          "label",
                                          { staticClass: "smallSelectorDescs" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.adult[_vm.getCurrentLocale]
                                              ) + ":"
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("v-select", {
                                          key: "k",
                                          ref: "noADT",
                                          staticClass: "style-chooser",
                                          staticStyle: {
                                            "margin-bottom": "20px",
                                          },
                                          attrs: {
                                            name: "noADT",
                                            options: _vm.getListOfPaxes,
                                            clearable: false,
                                            label: "v",
                                            value: "v",
                                          },
                                          on: {
                                            input:
                                              _vm.onSelect_DepartureAirportKeyDes,
                                          },
                                          model: {
                                            value: _vm.noADT,
                                            callback: function ($$v) {
                                              _vm.noADT = $$v
                                            },
                                            expression: "noADT",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-xs-2 col-md-2" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "selector",
                                        staticStyle: { "text-align": "end" },
                                      },
                                      [
                                        _c(
                                          "label",
                                          { staticClass: "smallSelectorDescs" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.child[_vm.getCurrentLocale]
                                              ) + ":"
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("v-select", {
                                          key: "k",
                                          ref: "noCHD",
                                          staticClass: "style-chooser",
                                          staticStyle: {
                                            "margin-bottom": "20px",
                                          },
                                          attrs: {
                                            name: "noCHD",
                                            options: _vm.getListOfPaxes,
                                            clearable: false,
                                            label: "v",
                                            value: "v",
                                          },
                                          on: {
                                            input:
                                              _vm.onSelect_DepartureAirportKeyDes,
                                          },
                                          model: {
                                            value: _vm.noCHD,
                                            callback: function ($$v) {
                                              _vm.noCHD = $$v
                                            },
                                            expression: "noCHD",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-xs-2 col-md-2" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "selector",
                                        staticStyle: { "text-align": "end" },
                                      },
                                      [
                                        _c(
                                          "label",
                                          { staticClass: "smallSelectorDescs" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.infant[_vm.getCurrentLocale]
                                              ) + ":"
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("v-select", {
                                          key: "k",
                                          ref: "noINF",
                                          staticClass: "style-chooser",
                                          staticStyle: {
                                            "margin-bottom": "20px",
                                          },
                                          attrs: {
                                            name: "noINF",
                                            options: _vm.getListOfPaxes,
                                            clearable: false,
                                            label: "v",
                                            value: "v",
                                          },
                                          on: {
                                            input:
                                              _vm.onSelect_DepartureAirportKeyDes,
                                          },
                                          model: {
                                            value: _vm.noINF,
                                            callback: function ($$v) {
                                              _vm.noINF = $$v
                                            },
                                            expression: "noINF",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "clearfix" }, [
                              _c("h4", { staticClass: "box-title pull-left" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.getOffersSelectedDestination.desCityName
                                  )
                                ),
                                _c("small", [
                                  _vm._v(
                                    _vm._s(_vm.nextmonths[_vm.getCurrentLocale])
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "price pull-right" }, [
                                _c(
                                  "small",
                                  { staticStyle: { "text-align": "end" } },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.from2[_vm.getCurrentLocale])
                                    ),
                                  ]
                                ),
                                _vm._v(
                                  _vm._s(
                                    _vm._f("rndAmntRUAFWZ")(
                                      _vm.getOffersSelectedDestination.price
                                    )
                                  )
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "character clearfix" }, [
                              _vm._m(38),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-xs-6 date" }, [
                                _c("i", {
                                  staticClass: "soap-icon-clock yellow-color",
                                }),
                                _vm._v(" "),
                                _c("div", [
                                  _c("span", { staticClass: "skin-color" }, [
                                    _vm._v(
                                      _vm._s(_vm.mydate[_vm.getCurrentLocale])
                                    ),
                                  ]),
                                  _c("br"),
                                  _vm._v(
                                    _vm._s(
                                      _vm.next6months[_vm.getCurrentLocale]
                                    ) +
                                      "\n                                        "
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-xs-6 departure" }, [
                                _c("i", {
                                  staticClass:
                                    "soap-icon-departure yellow-color",
                                }),
                                _vm._v(" "),
                                _c("div", [
                                  _c("span", { staticClass: "skin-color" }, [
                                    _vm._v(
                                      _vm._s(_vm.fromDes[_vm.getCurrentLocale])
                                    ),
                                  ]),
                                  _c("br"),
                                  _vm._v(
                                    _vm._s(_vm.choosenStartAirport) +
                                      "\n                                        "
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-xs-6 departure" }, [
                                _c("i", {
                                  staticClass:
                                    "soap-icon-departure yellow-color",
                                }),
                                _vm._v(" "),
                                _c("div", [
                                  _c("span", { staticClass: "skin-color" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.destination[_vm.getCurrentLocale]
                                      )
                                    ),
                                  ]),
                                  _c("br"),
                                  _vm._v(
                                    _vm._s(
                                      _vm.getOffersSelectedDestination
                                        .desCityName
                                    ) +
                                      ", " +
                                      _vm._s(
                                        _vm.getOffersSelectedDestination
                                          .destinationOfferAptCode
                                      ) +
                                      "\n                                        "
                                  ),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "clearfix" }),
                          ]
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm.getBookingOffersListFlightsMonthlyOffers.reduce(
                      function (a, b) {
                        return a + b
                      },
                      0
                    ) > 0
                      ? _c(
                          "div",
                          {
                            key: _vm.fakeCounter,
                            staticStyle: {
                              background: "#fff",
                              padding: "20px",
                            },
                          },
                          [
                            _c("sdr-shared-keydestinations-bar-charts", {
                              attrs: {
                                chartdata: this.get_barchartsChartdata(),
                                options: _vm.barchartsOptions,
                              },
                            }),
                            _vm._v(" "),
                            _vm.getBookingOffersChoosenFlightByUser === null
                              ? _c(
                                  "a",
                                  {
                                    staticClass:
                                      "button btn-large uppercase full-width silver",
                                    staticStyle: { "margin-top": "40px" },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.findflights[_vm.getCurrentLocale]
                                      )
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.getBookingOffersChoosenFlightByUser !== null
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn-large icon-check uppercase full-width",
                                    staticStyle: { "margin-top": "40px" },
                                    attrs: { type: "submit" },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        _vm.onClick_Submit_FindFlightsViaOffers()
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.getButtonName()))]
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]),
                ]),
              ]),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "index" }, [
      _c("i", { staticClass: "soap-icon-star circle" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "index" }, [
      _c("i", { staticClass: "soap-icon-star circle" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "floatingicon" }, [
      _c("i", {
        staticClass: "soap-icon-plane-right circle yellow-color takeoff-effect",
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "floatingicon" }, [
      _c("i", { staticClass: "soap-icon-hotel circle yellow-color" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "floatingicon" }, [
      _c("i", { staticClass: "soap-icon-hotel circle yellow-color" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "floatingicon" }, [
      _c("i", {
        staticClass: "soap-icon-plane-right circle yellow-color takeoff-effect",
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "floatingicon" }, [
      _c("i", { staticClass: "soap-icon-hotel circle yellow-color" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "floatingicon" }, [
      _c("i", { staticClass: "soap-icon-hotel circle yellow-color" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "floatingicon" }, [
      _c("i", {
        staticClass: "soap-icon-plane-right circle yellow-color takeoff-effect",
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "floatingicon" }, [
      _c("i", { staticClass: "soap-icon-hotel circle yellow-color" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "floatingicon" }, [
      _c("i", { staticClass: "soap-icon-hotel circle yellow-color" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "floatingicon" }, [
      _c("i", {
        staticClass: "soap-icon-plane-right circle yellow-color takeoff-effect",
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "floatingicon" }, [
      _c("i", { staticClass: "soap-icon-hotel circle yellow-color" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "floatingicon" }, [
      _c("i", { staticClass: "soap-icon-hotel circle yellow-color" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "floatingicon" }, [
      _c("i", {
        staticClass: "soap-icon-plane-right circle yellow-color takeoff-effect",
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "floatingicon" }, [
      _c("i", { staticClass: "soap-icon-hotel circle yellow-color" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "floatingicon" }, [
      _c("i", { staticClass: "soap-icon-hotel circle yellow-color" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "floatingicon" }, [
      _c("i", {
        staticClass: "soap-icon-plane-right circle yellow-color takeoff-effect",
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "floatingicon" }, [
      _c("i", { staticClass: "soap-icon-hotel circle yellow-color" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "floatingicon" }, [
      _c("i", { staticClass: "soap-icon-hotel circle yellow-color" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "floatingicon" }, [
      _c("i", {
        staticClass: "soap-icon-plane-right circle yellow-color takeoff-effect",
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "floatingicon" }, [
      _c("i", { staticClass: "soap-icon-hotel circle yellow-color" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "floatingicon" }, [
      _c("i", { staticClass: "soap-icon-hotel circle yellow-color" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "floatingicon" }, [
      _c("i", {
        staticClass: "soap-icon-plane-right circle yellow-color takeoff-effect",
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "floatingicon" }, [
      _c("i", { staticClass: "soap-icon-hotel circle yellow-color" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "floatingicon" }, [
      _c("i", { staticClass: "soap-icon-hotel circle yellow-color" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "floatingicon" }, [
      _c("i", {
        staticClass: "soap-icon-plane-right circle yellow-color takeoff-effect",
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "floatingicon" }, [
      _c("i", { staticClass: "soap-icon-hotel circle yellow-color" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "floatingicon" }, [
      _c("i", { staticClass: "soap-icon-hotel circle yellow-color" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "floatingicon" }, [
      _c("i", {
        staticClass: "soap-icon-plane-right circle yellow-color takeoff-effect",
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "floatingicon" }, [
      _c("i", { staticClass: "soap-icon-hotel circle yellow-color" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "floatingicon" }, [
      _c("i", { staticClass: "soap-icon-hotel circle yellow-color" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "floatingicon" }, [
      _c("i", {
        staticClass: "soap-icon-plane-right circle yellow-color takeoff-effect",
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "floatingicon" }, [
      _c("i", { staticClass: "soap-icon-hotel circle yellow-color" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "floatingicon" }, [
      _c("i", { staticClass: "soap-icon-hotel circle yellow-color" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "floatingicon" }, [
      _c("i", {
        staticClass: "soap-icon-plane-right circle yellow-color takeoff-effect",
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "floatingicon" }, [
      _c("i", { staticClass: "soap-icon-hotel circle yellow-color" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "floatingicon" }, [
      _c("i", { staticClass: "soap-icon-hotel circle yellow-color" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-xs-1 cruise-logo" }, [
      _c("img", {
        staticStyle: { height: "30px" },
        attrs: { src: "/res/images/logo-centered2.png", alt: "" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }